import { mainEndpoints } from '@/lib/api/endpoints'
import { mainApi } from '@/lib/api/http'
import type { FileRef } from '@/lib/api/common'

/**
 * Uploads one image and returns the stored file.
 *
 * The id, not the URL, is what the rest of the API takes: a banner is saved with
 * an `imageId`, a tenant with a `logoId`. The URL that comes back is only for
 * showing the merchant what they just picked.
 *
 * `Content-Type` is deliberately unset — axios fills in the multipart boundary,
 * and the client's JSON default would otherwise override it.
 */
export async function uploadFile(file: File): Promise<FileRef> {
  const body = new FormData()
  body.append('file', file)

  return await mainApi.post<FileRef>(mainEndpoints.fileUpload, body, {
    headers: { 'Content-Type': undefined },
  })
}
